import(/* webpackMode: "eager" */ "/var/directorder/app/main/apps/seller/src/app/layout.js");
